import { sample } from 'effector';
import {
  calculateThresholdsEv,
  putBlockedBucketsEv,
  putThresholdsEv,
  resetBlockedBucketsEv,
} from './events.js';
import { $blockedBuckets, $gradientBuckets } from './stores.js';
import { $activeFilters, selectAllEv } from '../activeFiltersModel/index.js';
import { bucketsByAlgorithmFx } from './effects.js';
import { getLessColors } from '../../utils/gradient-utils.js';
import { gradient_colors } from '../../dictionaries/gradient_dictionary.js';

$blockedBuckets.reset(resetBlockedBucketsEv);

sample({
  source: $blockedBuckets,
  clock: putBlockedBucketsEv,
  fn: (source, clock) => {
    return {
      ...source,
      [clock.zoom]: clock.value,
    };
  },
  target: $blockedBuckets,
});

sample({
  clock: selectAllEv,
  target: resetBlockedBucketsEv,
});

sample({
  source: $activeFilters,
  clock: calculateThresholdsEv,
  filter: (activeFilters) => activeFilters.gradient.length === 0,
  fn: (activeFilters, clock) => {
    return {
      hexagons: clock,
      algorithm: 'JNK',
    };
  },
  target: bucketsByAlgorithmFx,
});

sample({
  source: $gradientBuckets,
  clock: putThresholdsEv,
  fn: (gradientBuckets, clock) => {
    const buckets = clock;
    let { colors } = gradientBuckets;
    if (clock.length - 1 < 10) {
      colors = getLessColors(clock.length - 1);
    } else {
      colors = gradient_colors.light_reverse;
    }

    return {
      buckets,
      colors,
    };
  },
  target: $gradientBuckets,
});

sample({
  clock: bucketsByAlgorithmFx.doneData,
  target: putThresholdsEv,
});
